function orderedStops(locations) {
   return [...(locations || [])].sort((a, b) => (a.locationOrder ?? 0) - (b.locationOrder ?? 0));
}

function isSameStop(a, b) {
   if (!a || !b) {
      return false;
   }
   if (a.id && b.id && a.id === b.id) {
      return true;
   }
   return a.locationOrder != null && b.locationOrder != null && a.locationOrder === b.locationOrder;
}

function resolveStop(vehicle, locations, ordered, which) {
   const nav = which === 'from' ? vehicle.TripLocation : vehicle.TripLocation1;
   if (nav) {
      return nav;
   }
   const index = which === 'from' ? vehicle.fromLocation : vehicle.toLocation;
   if (index == null || !locations) {
      return null;
   }
   if (locations[index]) {
      return locations[index];
   }
   return ordered.find((l) => l.locationOrder === index || l.locationOrder === index + 1) || null;
}

export function vehicleRole(vehicle, locations) {
   const ordered = orderedStops(locations);
   const first = ordered[0];
   const from = resolveStop(vehicle, locations, ordered, 'from');
   const to = resolveStop(vehicle, locations, ordered, 'to');
   if (!from || !to || !first) {
      return 'delivery';
   }
   const fromFirst = isSameStop(from, first);
   const toOrigin = isSameStop(to, first)
      || (to.dealershipId != null && first.dealershipId != null && to.dealershipId === first.dealershipId)
      || (to.place_id && first.place_id && to.place_id === first.place_id)
      || (to.Dealership?.googlePlaceId && first.Dealership?.googlePlaceId
         && to.Dealership.googlePlaceId === first.Dealership.googlePlaceId);
   if (fromFirst && toOrigin) {
      return 'roundTrip';
   }
   if (fromFirst) {
      return 'delivery';
   }
   return 'return';
}

export function vehicleRoleLabel(role) {
   if (role === 'roundTrip') {
      return 'Round trip';
   }
   if (role === 'return') {
      return 'Return';
   }
   return 'Delivery';
}

function isChaseVehicle(v) {
   if (!v) {
      return false;
   }
   if (v.isChase) {
      return true;
   }
   return String(v.vehicleVIN || '').trim().toLowerCase() === 'chase';
}

function startLocationOrder(vehicle, locations) {
   if (vehicle?.TripLocation?.locationOrder != null) {
      return vehicle.TripLocation.locationOrder;
   }
   const ordered = orderedStops(locations);
   const from = resolveStop(vehicle, locations, ordered, 'from');
   if (from?.locationOrder != null) {
      return from.locationOrder;
   }
   return 1;
}

/** Chase, Delivery (starts at location order 1), or Return (starts later). */
export function vehicleTypeLabel(vehicle, locations) {
   if (isChaseVehicle(vehicle)) {
      return 'Chase';
   }
   return startLocationOrder(vehicle, locations) > 1 ? 'Return' : 'Delivery';
}
